<oo-loading-container [status]="state.status">
  <ng-template>
    <mat-card appearance="outlined">
      <mat-card-content>
        @if (state.competitionGroups.length) {
          <mat-nav-list>
            @for (compGroup of state.competitionGroups; track compGroup) {
              <a [routerLink]="['./', compGroup.id]" mat-list-item>
                <img [src]="compGroup.tournament.image ?? 'https://ui-avatars.com/api/?size=50&name=' + compGroup.name"
                     class="oo-list-image" matListItemAvatar>
                <span matListItemTitle>{{ compGroup.name }}</span>
              </a>
            }
          </mat-nav-list>
        }
        @if (!state.competitionGroups.length) {
          <div data-t="noCompetition" matListItemTitle>
            No competitions, please create one
          </div>
        }
      </mat-card-content>
    </mat-card>

    <button (click)="openCreateTournamentDialog()" class="oo-create-tournament-btn" mat-fab>
      <mat-icon>add</mat-icon>
    </button>
  </ng-template>
</oo-loading-container>
